var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from "react";
import { Component as ReactComponent, useEffect, useRef, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation, matchPath } from "react-router-dom";
import { generateRoute } from "@js/common/helpers";
import * as tts from "@js/common/tts";
import { toggleRegisterPromptModal } from "@js/common/auth/modalHandler";
import { closeViewer } from "@ts/common/components/viewer";
var RouterErrorBoundary = (function (_super) {
    __extends(RouterErrorBoundary, _super);
    function RouterErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { hasError: false };
        return _this;
    }
    RouterErrorBoundary.getDerivedStateFromError = function () {
        return { hasError: true };
    };
    RouterErrorBoundary.prototype.componentDidCatch = function (error) {
        console.error('BrowseRouter: page component crashed', error);
        window.location.reload();
    };
    RouterErrorBoundary.prototype.render = function () {
        if (this.state.hasError) {
            return null;
        }
        return this.props.children;
    };
    return RouterErrorBoundary;
}(ReactComponent));
var renderKeySeq = 0;
function routePath(routeName) {
    return new URL(generateRoute(routeName, {}), window.location.origin).pathname;
}
function localePrefix() {
    return routePath('collection_search').replace(/\/collection\/search$/, '');
}
var ROUTES = [
    {
        entrypoint: 'look_search_v2',
        pattern: function () { return routePath('look_search'); },
        load: function () { return import("@ts/look/page/SearchPage"); },
        exportName: 'SearchPage',
        hasGrid: true,
        selfReportsPageView: true,
    },
    {
        entrypoint: 'collection_search_v2',
        pattern: function () { return routePath('collection_search'); },
        load: function () { return import("@ts/collection/page/SearchPage"); },
        exportName: 'SearchPage',
        hasGrid: true,
        selfReportsPageView: true,
    },
    {
        entrypoint: 'collection_show',
        pattern: function () { return localePrefix() + "/collection/:type/:designer/:season"; },
        load: function () { return import("@ts/collection/page/CollectionShowPage"); },
        exportName: 'CollectionShowPage',
        hasGrid: true,
        selfReportsPageView: true,
    },
    {
        entrypoint: 'collection_show',
        pattern: function () { return localePrefix() + "/collection/:slug"; },
        load: function () { return import("@ts/collection/page/CollectionShowPage"); },
        exportName: 'CollectionShowPage',
        hasGrid: true,
        selfReportsPageView: true,
    },
    {
        entrypoint: 'live_show',
        pattern: function () { return localePrefix() + "/live/:type/:season"; },
        load: function () { return import("@ts/live/page/LiveShowPage"); },
        exportName: 'LiveShowPage',
        hasGrid: true,
        selfReportsPageView: false,
    },
    {
        entrypoint: 'page_live',
        pattern: function () { return routePath('page_live'); },
        load: function () { return import("@ts/live/page/LiveShowPage"); },
        exportName: 'LiveShowPage',
        hasGrid: true,
        selfReportsPageView: false,
    },
    {
        entrypoint: 'collection_review',
        pattern: function () { return localePrefix() + "/collection-review/:slug"; },
        load: function () { return import("@ts/collection/page/ReviewPage"); },
        exportName: 'ReviewPage',
        hasGrid: false,
        selfReportsPageView: false,
    },
    {
        entrypoint: 'collection_show_team',
        pattern: function () { return localePrefix() + "/collection-show-team/:slug"; },
        load: function () { return import("@ts/collection/page/ShowTeamPage"); },
        exportName: 'ShowTeamPage',
        hasGrid: false,
        selfReportsPageView: false,
    },
    {
        entrypoint: 'model_index',
        pattern: function () { return routePath('models_index'); },
        load: function () { return import("@ts/model/page/ModelIndexPage"); },
        exportName: 'ModelIndexPage',
        hasGrid: false,
        selfReportsPageView: false,
    },
    {
        entrypoint: 'model_search',
        pattern: function () { return routePath('models_search'); },
        load: function () { return import("@ts/model/page/ModelSearchPage"); },
        exportName: 'ModelSearchPage',
        hasGrid: false,
        selfReportsPageView: true,
    },
    {
        entrypoint: 'model_show',
        pattern: function () { return localePrefix() + "/model/:slug"; },
        load: function () { return import("@ts/model/page/ModelShowPage"); },
        exportName: 'ModelShowPage',
        hasGrid: true,
        selfReportsPageView: true,
        tab: 'looks',
    },
    {
        entrypoint: 'model_show',
        pattern: function () { return localePrefix() + "/model/:slug/informations"; },
        load: function () { return import("@ts/model/page/ModelShowPage"); },
        exportName: 'ModelShowPage',
        hasGrid: false,
        selfReportsPageView: false,
        tab: 'informations',
    },
    {
        entrypoint: 'member_show',
        pattern: function () { return localePrefix() + "/members/:slug"; },
        load: function () { return import("@ts/member/page/MemberShowPage"); },
        exportName: 'MemberShowPage',
        hasGrid: true,
        selfReportsPageView: true,
        tab: 'shows',
    },
    {
        entrypoint: 'member_show',
        pattern: function () { return localePrefix() + "/members/:slug/informations"; },
        load: function () { return import("@ts/member/page/MemberShowPage"); },
        exportName: 'MemberShowPage',
        hasGrid: false,
        selfReportsPageView: false,
        tab: 'informations',
    },
];
var initialLoadConsumed = false;
var routerMounted = false;
function countParams(pattern) {
    var _a;
    return ((_a = pattern.match(/:[^/]+/g)) !== null && _a !== void 0 ? _a : []).length;
}
function updateMainDataRoute(routeName) {
    var _a;
    if (typeof routeName !== 'string') {
        return;
    }
    (_a = document.querySelector('main')) === null || _a === void 0 ? void 0 : _a.setAttribute('data-route', routeName);
}
function syncMainAnalyticsAttributes(routeParams) {
    var _a, _b, _c, _d;
    var main = document.querySelector('main');
    if (!main) {
        return;
    }
    var params = new URLSearchParams(window.location.search);
    main.setAttribute('data-route-params', JSON.stringify(routeParams !== null && routeParams !== void 0 ? routeParams : {}));
    main.setAttribute('data-current-page', (_a = params.get('page')) !== null && _a !== void 0 ? _a : '1');
    main.setAttribute('data-utm-source', (_b = params.get('utm_source')) !== null && _b !== void 0 ? _b : '');
    main.setAttribute('data-utm-content', (_c = params.get('utm_content')) !== null && _c !== void 0 ? _c : '');
    main.setAttribute('data-source', (_d = params.get('source')) !== null && _d !== void 0 ? _d : '');
    main.removeAttribute('data-photos');
    main.removeAttribute('data-query');
}
function syncTdsClass(tds) {
    document.documentElement.classList.toggle('tds', tds === true);
}
function resetPaywallWidget() {
    var widget = document.querySelector('#pw-widget');
    if (!widget) {
        return;
    }
    widget.innerHTML = '';
    widget.classList.remove('fixed', 'd-none');
}
function findRoute(pathname) {
    var matches = ROUTES.filter(function (route) { return matchPath({ path: route.pattern(), end: true }, pathname) !== null; });
    if (matches.length === 0) {
        return null;
    }
    return matches.reduce(function (best, candidate) { return (countParams(candidate.pattern()) < countParams(best.pattern()) ? candidate : best); });
}
function AppShell() {
    var _this = this;
    var _a, _b;
    var location = useLocation();
    var _c = useState(null), current = _c[0], setCurrent = _c[1];
    var _d = useState(false), isNavigating = _d[0], setIsNavigating = _d[1];
    var isFirstRunRef = useRef(true);
    var requestIdRef = useRef(0);
    useEffect(function () {
        var requestId = ++requestIdRef.current;
        var isInitialLoad = isFirstRunRef.current && !initialLoadConsumed;
        isFirstRunRef.current = false;
        initialLoadConsumed = true;
        var route = findRoute(location.pathname);
        if (!route) {
            return;
        }
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var modulePromise, resolvedAppData, resolvedRoute, resolvedRouteParams, resolvedTds, url, fallbackUrl, response, _a, payload_1, _b, targetIsRoutable, loadedModule, error_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        modulePromise = route.load();
                        url = location.pathname + location.search;
                        fallbackUrl = url;
                        if (!!isInitialLoad) return [3, 9];
                        setIsNavigating(true);
                        response = void 0;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4, fetch(url, {
                                headers: { 'X-Requested-With': 'XMLHttpRequest' },
                            })];
                    case 2:
                        response = _c.sent();
                        return [3, 4];
                    case 3:
                        _a = _c.sent();
                        window.location.href = url;
                        return [2];
                    case 4:
                        fallbackUrl = response.url || url;
                        if (!response.ok) {
                            window.location.href = fallbackUrl;
                            return [2];
                        }
                        _c.label = 5;
                    case 5:
                        _c.trys.push([5, 7, , 8]);
                        return [4, response.json()];
                    case 6:
                        payload_1 = _c.sent();
                        return [3, 8];
                    case 7:
                        _b = _c.sent();
                        window.location.href = fallbackUrl;
                        return [2];
                    case 8:
                        if (!payload_1 || typeof payload_1.entrypoint !== 'string') {
                            window.location.href = fallbackUrl;
                            return [2];
                        }
                        if (payload_1.entrypoint !== route.entrypoint) {
                            targetIsRoutable = ROUTES.some(function (r) { return r.entrypoint === payload_1.entrypoint; });
                            if (targetIsRoutable) {
                                replaceAndNotify(new URL(fallbackUrl, window.location.origin));
                            }
                            else {
                                window.location.replace(fallbackUrl);
                            }
                            return [2];
                        }
                        resolvedAppData = payload_1.app_data;
                        resolvedRoute = payload_1.route;
                        resolvedRouteParams = payload_1.route_params;
                        resolvedTds = payload_1.tds;
                        _c.label = 9;
                    case 9:
                        _c.trys.push([9, 11, , 12]);
                        return [4, modulePromise];
                    case 10:
                        loadedModule = _c.sent();
                        return [3, 12];
                    case 11:
                        error_1 = _c.sent();
                        console.error('BrowseRouter: page chunk failed to load', error_1);
                        window.location.href = fallbackUrl;
                        return [2];
                    case 12:
                        if (requestIdRef.current === requestId) {
                            if (resolvedAppData !== undefined) {
                                window.appData = resolvedAppData;
                                updateMainDataRoute(resolvedRoute);
                                syncMainAnalyticsAttributes(resolvedRouteParams);
                                syncTdsClass(resolvedTds);
                                resetPaywallWidget();
                                if (!route.selfReportsPageView) {
                                    tts.page(undefined, true);
                                }
                                if (localStorage.getItem('auth') === 'anonymous') {
                                    toggleRegisterPromptModal();
                                }
                            }
                            setCurrent({ Component: loadedModule[route.exportName], renderKey: ++renderKeySeq });
                            setIsNavigating(false);
                        }
                        return [2];
                }
            });
        }); })();
    }, [location.pathname, location.search]);
    if (!current) {
        return null;
    }
    var Component = current.Component;
    var pendingRoute = isNavigating ? findRoute(location.pathname) : null;
    var pendingParams = pendingRoute
        ? (_a = matchPath({ path: pendingRoute.pattern(), end: true }, location.pathname)) === null || _a === void 0 ? void 0 : _a.params
        : null;
    return (React.createElement(RouterErrorBoundary, { key: current.renderKey },
        React.createElement(Component, { isTransitioning: isNavigating && ((_b = pendingRoute === null || pendingRoute === void 0 ? void 0 : pendingRoute.hasGrid) !== null && _b !== void 0 ? _b : false), pendingNavigation: pendingRoute ? { entrypoint: pendingRoute.entrypoint, params: pendingParams !== null && pendingParams !== void 0 ? pendingParams : {}, tab: pendingRoute.tab } : undefined })));
}
export function BrowseApp() {
    return (React.createElement(BrowserRouter, null,
        React.createElement(Routes, null,
            React.createElement(Route, { path: "*", element: React.createElement(AppShell, null) }))));
}
function isSoftNavigable(pathname) {
    return findRoute(pathname) !== null;
}
function pushAndNotify(url) {
    window.history.pushState(null, '', url.toString());
    window.dispatchEvent(new PopStateEvent('popstate'));
}
function replaceAndNotify(url) {
    window.history.replaceState(null, '', url.toString());
    window.dispatchEvent(new PopStateEvent('popstate'));
}
export function softNavigate(href) {
    var url = new URL(href, window.location.href);
    if (!routerMounted || url.origin !== window.location.origin || !isSoftNavigable(url.pathname)) {
        window.location.href = href;
        return;
    }
    if (url.pathname === window.location.pathname && url.search === window.location.search) {
        return;
    }
    pushAndNotify(url);
}
function onDocumentClick(event) {
    var _a, _b;
    if (event.defaultPrevented
        || event.button !== 0
        || event.metaKey
        || event.ctrlKey
        || event.shiftKey
        || event.altKey) {
        return;
    }
    var anchor = (_b = (_a = event.target) === null || _a === void 0 ? void 0 : _a.closest) === null || _b === void 0 ? void 0 : _b.call(_a, 'a');
    if (!anchor || !anchor.href || anchor.target === '_blank') {
        return;
    }
    var url = new URL(anchor.href, window.location.href);
    if (url.origin !== window.location.origin || !isSoftNavigable(url.pathname)) {
        return;
    }
    var isSamePathAndQuery = url.pathname === window.location.pathname && url.search === window.location.search;
    if (isSamePathAndQuery && url.hash !== '' && url.hash !== window.location.hash) {
        return;
    }
    event.preventDefault();
    if (isSamePathAndQuery) {
        return;
    }
    closeViewer();
    pushAndNotify(url);
}
export function initClickBridge() {
    if (routerMounted) {
        return;
    }
    routerMounted = true;
    document.addEventListener('click', onDocumentClick);
}
